// import { useState } from "react";
// import ImageUpload from "../components/imageupload";

// export default function FactoryImages() {
//   const [files, setFiles] = useState<File[]>([]);

//   const handleSubmit = (e: React.FormEvent) => {
//     e.preventDefault();
//     // TODO: send `files` via fetch / axios / react-query, etc.
//     alert(`${files.length} image(s) ready to upload!`);
//   };

//   return (
//     <section className="p-6">
//       <h1 className="text-2xl font-semibold mb-4">Factory Image Upload</h1>
//       <form
//         onSubmit={handleSubmit}
//         className="space-y-6 bg-white p-6 rounded-xl shadow"
//       >
//         <ImageUpload
//           label="Factory Photos"
//           multiple
//           onFilesSelected={setFiles}
//         />

//         <button
//           type="submit"
//           disabled={files.length === 0}
//           className="px-4 py-2 rounded-lg bg-indigo-600 text-white disabled:opacity-50"
//         >
//           Upload {files.length > 0 ? `(${files.length})` : ""}
//         </button>
//       </form>
//     </section>
//   );
// }

import { useEffect, useState } from "react";
import ImageUpload from "../components/imageupload";

interface FactoryRecord {
  id: number;
  created_at: string;
  image_urls: string[];
}

const API_URL =
  "https://adinsinternational.com/websitebackend/factory_image_api.php";

export default function FactoryImages() {
  const [files, setFiles] = useState<File[]>([]);
  const [factoryImages, setFactoryImages] = useState<FactoryRecord[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchFactoryImages = async () => {
    try {
      const res = await fetch(API_URL);
      const json = await res.json();
      if (json.status === "success") setFactoryImages(json.data);
    } catch (err) {
      console.error("Failed to fetch factory images", err);
    }
  };

  useEffect(() => {
    fetchFactoryImages();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (files.length === 0) return;
    setLoading(true);

    try {
      const formData = new FormData();
      files.forEach((f) => formData.append("images[]", f, f.name)); // ✅ Ensure filename is included

      const res = await fetch(API_URL, {
        method: "POST",
        body: formData,
      });

      const json = await res.json();

      if (json.status === "success") {
        setFiles([]);
        await fetchFactoryImages();
        alert("Factory images uploaded ✅");
      } else {
        console.error("Server error:", json);
        alert(json.message || "Upload failed ❌");
      }
    } catch (err) {
      console.error("Upload error", err);
      alert("Upload error ❌");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id: number) => {
    if (!window.confirm("Are you sure to delete this factory image entry?"))
      return;

    try {
      const res = await fetch(API_URL, {
        method: "DELETE",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ id: id.toString() }),
      });

      const json = await res.json();
      if (json.status === "success") {
        setFactoryImages((prev) => prev.filter((img) => img.id !== id));
        alert("Deleted successfully ✅");
      } else {
        alert(json.message || "Delete failed ❌");
      }
    } catch (err) {
      console.error("Delete error", err);
      alert("Delete failed ❌");
    }
  };

  return (
    <section className="p-6 space-y-10">
      <h1 className="text-2xl font-semibold mb-4">Factory Image Upload</h1>

      <form
        onSubmit={handleSubmit}
        className="space-y-6 bg-white p-6 rounded-xl shadow"
      >
        <ImageUpload
          label="Factory Photos"
          multiple
          onFilesSelected={setFiles}
        />

        <button
          type="submit"
          disabled={files.length === 0 || loading}
          className="px-4 py-2 rounded-lg bg-indigo-600 text-white disabled:opacity-50"
        >
          {loading ? "Uploading…" : `Upload (${files.length})`}
        </button>
      </form>

      <div>
        <h2 className="text-xl font-semibold mb-4">Uploaded Factory Images</h2>
        <ul className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {factoryImages.map((record) => (
            <li key={record.id} className="bg-white rounded-xl shadow p-4">
              <p className="text-sm text-gray-500 mb-2">
                {record.created_at !== "0000-00-00 00:00:00"
                  ? new Date(record.created_at).toLocaleString()
                  : "N/A"}
              </p>
              <div className="space-y-2">
                {record.image_urls.map((url, index) => (
                  <img
                    key={index}
                    src={url}
                    alt={`Factory image ${index + 1}`}
                   className="w-80 h-80 object-cover rounded-lg border border-gray-200"
                    loading="lazy"
                  />
                ))}
              </div>

              <button
                className="mt-4 w-full text-sm text-white bg-red-600 rounded-lg py-2 hover:bg-red-700"
                onClick={() => handleDelete(record.id)}
              >
                Delete
              </button>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
